module.exports = __webpack_public_path__ + "img/edge_activites_rando_equestre.c2167d76.svg";